import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  className?: string
  isDisabled?: boolean
}

export function CampaignButton({
  children,
  isDisabled = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={`
        h-10 rounded-full flex-col justify-center items-center gap-2 inline-flex
        ${
          isDisabled
            ? 'bg-[#e3e3e4]' // Light gray background for disabled state
            : 'bg-[#000000]'
        }
        ${className}
      `}
      {...props}
    >
      <div
        className={`
          self-stretch grow shrink basis-0 px-2 py-2.5 justify-center items-center gap-2 inline-flex
          ${
            isDisabled
              ? '' // No hover effect needed for disabled state
              : 'hover:bg-white/10 active:bg-white/12'
          }
        `}
      >
        <div
          className={`
            text-center font-['Geist'] leading-tight tracking-tight font-medium text-2xl
            ${
              isDisabled
                ? 'text-[#98979a]' // Specific gray color for disabled text
                : 'text-white'
            }
          `}
        >
          {children}
        </div>
      </div>
    </button>
  )
}
